package nl.astraeus.wiki.messages

class GoogleLoginMessage() : Message(
  MessageType.GOOGLE_LOGIN,
  MessageHeader.GOOGLE_CODE,
  MessageHeader.OAUTH_STATE,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(code: String, state: String) : this() {
    setHeader(MessageHeader.GOOGLE_CODE, code)
    setHeader(MessageHeader.OAUTH_STATE, state)
  }
}

class GoogleLoginResult() : Message(
  MessageType.GOOGLE_LOGIN_RESPONSE,
  MessageHeader.RESULT,
  MessageHeader.REASON,
  MessageHeader.USER_EMAIL,
  MessageHeader.USER_NAME,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(
    id: String,
    result: String,
    errorMessage: String,
    email: String,
    name: String,
  ) : this() {
    setHeader(MessageHeader.MESSAGE_ID, id)
    setHeader(MessageHeader.RESULT, result)
    setHeader(MessageHeader.REASON, errorMessage)
    setHeader(MessageHeader.USER_EMAIL, email)
    setHeader(MessageHeader.USER_NAME, name)
  }

}
